module.exports = __webpack_public_path__ + "img/GAME_CARDRIVE1.3398541f.jpg";